import { CommonService } from './../../../modules/stp-operations/services/common.service';
import { AuthenticationService } from 'src/app/modules/authentication/services/authentication.service';
import { Component, OnInit } from '@angular/core';
import { applicationPermissions } from '../../application-constants/application-permissions';
import { AuthorizationService } from 'src/app/modules/authorization/services/authorization.service';
import { RequestData } from 'src/app/modules/stp-registration/models/stp_onlinePayment.model';
import { StpRegistrationStorageService } from 'src/app/modules/stp-registration/services/stp-registration-storage.service';
import { StpRegistrationService } from 'src/app/modules/stp-registration/services/stp-registration.service';
import { Router } from '@angular/router';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { environment } from 'src/environments/environment';
import { Subscription } from 'rxjs';
import { ServerResponse } from '../../models/dto/server-response.dto';
import { applicationUrls } from '../../../shared/application-constants/application-urls.const';



import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import { LoginResponse } from '../../../modules/authentication/models/login-response.dto';
import { CertificateService } from '../../services/certificate.service';
import { StpExpiryService, StpExpiryStatus } from '../../services/stp-expiry.service';

export interface ModuleCount {
  moduleName: string;
  moduleId: any;
  unreadCount: number;
}

export interface UnreadNotificationResponse {
  totalUnread: number;
  moduleUnreadCounts: ModuleCount[];
}

interface NotificationItem {
  notificationId?: number;
  id?: number;
  title?: string;
  message?: string;
  url?: string;
  isRead?: boolean;
  createdAt?: string;
  readAt?: string;
  moduleName?: string;
  moduleId?: number;
  remarks?: string;
}


(pdfMake as any).vfs = pdfFonts.pdfMake.vfs;
@Component({
  selector: 'app-default-layout',
  templateUrl: './default-layout.component.html',
  styleUrls: ['./default-layout.component.scss'],
})
export class DefaultLayoutComponent implements OnInit {
  private readonly notificationDrawerPageSize = 100;

  isNotificationOpen = false;
  countVisible = false;
  requestData: RequestData = new RequestData();
  userInfo: any;
  stpMainId: any;
  isCollapsed = false;
  stpApplication: any;
  isComplete: boolean;
  isComplete$: Subscription;
  applicationPermissions = applicationPermissions;
  environment = environment;
  stpMasterId = environment.roles.stpMasterId;
  stpBasicId = environment.roles.stpBasicId;
  isCertificateModalVisible: boolean = false;
  isOk: boolean = false;

  stpMainInfo$: Subscription;
  stpMainInfo: any;
  registrationNumber: any;
  stpName: any;

  stpExpiryStatus$: Subscription;
  stpExpiryStatus: StpExpiryStatus | null = null;
  stpExpiryWarningDays = 90; // same as the renewal window: renewal opens 90 days before expiry

  userInfoId! : any;

  currentUser!: LoginResponse | null;
  readonly defaultProfileImageUrl = 'assets/images/defaultUser.png';
  imageUrl: any = this.defaultProfileImageUrl;
  userIdValue : any;

  totalUnread: number;
  dummyNotificationData: any;
  moduleUnreadCounts: ModuleCount[];
  notificationItems: NotificationItem[] = [];
  selectedNotificationModuleId: number | null = null;
  selectedNotificationModuleName = '';
  notificationListLoading = false;

  notificationData: UnreadNotificationResponse = {
    totalUnread: 0,
    moduleUnreadCounts: []
  };

  constructor(
    private stpRegistrationStorageService: StpRegistrationStorageService,
    public authorizationService: AuthorizationService,
    private authenticationService: AuthenticationService,
    private stpRegistrationService: StpRegistrationService,
    private notification: NzNotificationService,
    private router: Router,
    private commonService: CommonService,
    private certificateService: CertificateService,
    public stpExpiryService: StpExpiryService,
  ) {
    let currentUserInfo: LoginResponse = JSON.parse(
      localStorage.getItem('currentUserInfo') ?? '{}'
    );

    this.stpExpiryStatus$ = this.stpExpiryService.status$.subscribe(
      (status) => {
        this.stpExpiryStatus = status;
      }
    );

    if (currentUserInfo?.id != null) {
      this.checkComplete(currentUserInfo.id);
    } else {
      this.stpExpiryService.clear();
    }

    this.stpMainInfo$ = this.stpRegistrationService
      .getStpMainInfo()
      .subscribe((res) => {
        this.stpMainInfo = res;
      });
  }

  checkComplete(userId: number): void {
    this.stpRegistrationStorageService
      .getlUserInfoById(userId)
      .subscribe((rs) => {
        if (rs.success) {
          let data = rs.data;
          this.registrationNumber = data?.stpMain?.registrationNo;
          this.stpName = data?.stpMain?.stpName;
        }
        this.stpExpiryService.setStpMain(rs.success ? rs.data?.stpMain : null);
      });
  }

  // The STP dashboard shows its own expiry card, so the global banner is not repeated there.
  get showStpExpiredBanner(): boolean {
    return (
      !!this.stpExpiryStatus?.isExpired &&
      this.stpExpiryStatus.hasRegistration &&
      !this.isStpDashboardRoute
    );
  }

  get showStpExpiringWarning(): boolean {
    const days = this.stpExpiryStatus?.expiresInDays;
    return (
      !this.stpExpiryStatus?.isExpired &&
      days != null &&
      days >= 0 &&
      days <= this.stpExpiryWarningDays &&
      !this.isStpDashboardRoute
    );
  }

  get isStpDashboardRoute(): boolean {
    return this.router.url.startsWith('/home/stp-dashboard');
  }

  onStpRenew(): void {
    this.router.navigate(['home/stp-registration/application-list-stp']);
  }

  ngOnInit() {
    this.initializeUserId();
    this.userId();
    this.getUnreadNotificationCount();
    this.onUserFullInformationRequest();

    this.isComplete$ = this.stpRegistrationService
      .getCheckIsCompleteRegistration()
      .subscribe((res) => {
        this.isComplete = res;
      });


       this.currentUser = this.authenticationService.CurrentUserValue;
       this.userIdValue = this.currentUser?.id;
       this.imageUrl = this.userIdValue
         ? `${applicationUrls.user.getProfileImageInfo}/${this.userIdValue}`
         : this.defaultProfileImageUrl;

  }

  userId() {
    this.userInfo = JSON.parse(localStorage.getItem('currentUserInfo') || '{}');
    this.requestData.id = this.userInfo.id;
  }

  initializeUserId(): void {
    const raw = localStorage.getItem('currentUserInfo') || '{}';
    this.userInfo = JSON.parse(raw);

    if (this.userInfo && typeof this.userInfo.id === 'number') {
      this.userInfoId = this.userInfo.id;
      this.requestData.id = this.userInfoId;
    } else {
      console.warn('No valid userId found in localStorage');
    }
  }

  onUserFullInformationRequest() {
    this.stpRegistrationStorageService
      .stpMainIdByUserId(this.requestData)
      .subscribe({
        next: (res) => {
          if (res.success) {
            this.stpMainId = res.data;
          }
        },
      });
  }


  onLogout(): void {
    localStorage.setItem('logout-tabs', Math.random().toString());
    this.authenticationService.logout();
  }
  onChangePassword(): void {
    this.router.navigate(['/home/authentication/change-password']);
  }

  //Online Payment Part redirect to ek pay.
  constructRequestData() {
    this.userInfo = JSON.parse(localStorage.getItem('currentUserInfo') || '{}');
    this.requestData.id = this.userInfo?.id;
  }

  onSubmitPaymentRequest() {
    // this.constructRequestData();
    // this.stpRegistrationStorageService
    //   .initiatePaymentRequest(this.requestData)
    //   .subscribe((response) => {
    //     window.location.href = response.data;
    //   });
    window.location.href = 'https://admin.ekpay.gov.bd/';
  }

  //#region modal
  showModal(): void {
    this.isCertificateModalVisible = true;
  }

  handleCancel(): void {
    this.isCertificateModalVisible = false;
  }
  handleOk(): void {
    this.isOk = true;
    this.isCertificateModalVisible = false;
    this.downloadCertificate(this.stpMainId);
  }
  //#endregion

  // downloadCertificate(stpId: number) {
  //   if (!stpId) {
  //     this.notification.error(
  //       'Sorry!',
  //       'Please fill Up your forms first.'
  //     );
  //   } else {
  //     this.stpRegistrationStorageService
  //       .readStpApplicationsbyId(stpId)
  //       .subscribe(
  //         (res) => {
  //           this.stpApplication = res.data;
  //           if (res.success) {
  //             if (!this.stpApplication.stpUserInfoDto.stpRegistrationNo || (this.stpApplication.stpUserInfoDto.approvalStatus == false)) {
  //               this.notification.error(
  //                 'Sorry!',
  //                 'Your STP Registration is not approved yet.'
  //               );
  //             } else {
  //               this.stpRegistrationStorageService
  //                 .getCertificateInformation(stpId)
  //                 .subscribe((data: any) => {
  //                   var fileName = 'report.pdf';
  //                   const contentDisposition = data.headers.get('Content-Disposition');
  //                   if (contentDisposition) {
  //                     const fileNameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
  //                     const matches = fileNameRegex.exec(contentDisposition);
  //                     if (matches != null && matches[1]) {
  //                       fileName = matches[1].replace(/['"]/g, '');
  //                     }
  //                     FileSaver(data.body, fileName);
  //                     {
  //                       this.notification.success('Success!', "STP Certificate download completed");
  //                     }
  //                   }
  //                 },
  //                   (error) => {
  //                     this.notification.error('Error!', "STP Certificate could not be downloaded");
  //                   });
  //             }
  //           }
  //         });
  //   }
  // }

  downloadCertificate(stpId: number) {
    if (!stpId) {
      this.notification.error('Sorry!', 'Please fill Up your forms first.');
    } else {
      this.stpRegistrationStorageService
        .readStpApplicationsbyId(stpId)
        .subscribe((res) => {
          this.stpApplication = res.data;
          if (res.success) {
            if (
              !this.stpApplication.stpUserInfoDto.stpRegistrationNo ||
              this.stpApplication.stpUserInfoDto.approvalStatus == false
            ) {
              this.notification.error(
                'Sorry!',
                'Your STP Registration is not approved yet.'
              );
            } else {
              this.stpRegistrationStorageService
                .getCertificateInformation(stpId)
                .subscribe({
                  next: (response: ServerResponse) => {
                    if (!response?.success) {
                      this.notification.error(
                        'Error',
                        response?.message || 'Something went wrong!'
                      );
                      return;
                    }
                    this.certificateService.onDownloadSTPCertificate(response.data);
                  },
                  error: (error: any) => {
                    console.error('API Error:', error);
                    this.notification.error(
                      'Error',
                      'Certificate download failed due to missing or incomplete data. Please try again.'
                    );
                  },
                });
            }
          }
        });
    }
  }

  userProfile(): void {
    this.router.navigate(['home/setting/my-profile']);
  }

  onProfileImageError(event: Event): void {
    const imageElement = event.target as HTMLImageElement;
    this.imageUrl = this.defaultProfileImageUrl;
    imageElement.src = this.defaultProfileImageUrl;
  }

  ngOnDestroy(): void {
    this.isComplete$.unsubscribe();
    this.stpExpiryStatus$?.unsubscribe();
  }


 nzCollapsed(): void {
  if (window.innerWidth <= 768) {
    this.isCollapsed = true;
  }
}



  getUnreadNotificationCount() {
    this.commonService.getUnreadNotificationCount().subscribe({
      next: (res: any) => {
        if (res) {
          this.notificationData = {
            totalUnread: res.totalUnread ?? 0,
            moduleUnreadCounts: res.moduleUnreadCounts ?? []
          };
        }
      },
      error: (err) => console.error('Failed to load unread counts', err)
    });
  }

  goToModule(moduleId: number) {
    this.router.navigate(['home', 'notification', 'details', moduleId]);
  }


  clearAllNotifications() {
    this.isNotificationOpen = false;
    this.notificationItems = [];
    this.selectedNotificationModuleId = null;
    this.selectedNotificationModuleName = '';
  }


// in your layout or notif component
  onBellOpen(open: boolean) {
    this.isNotificationOpen = open;

    if (open) {
      this.refreshNotificationTray();
    } else {
      this.clearAllNotifications();
    }
  }

  refreshNotificationTray(): void {
    this.loadDefaultNotificationModule();
  }

  loadDefaultNotificationModule(): void {
    this.commonService.getUnreadNotificationCount().subscribe({
      next: (res: any) => {
        const notificationData: UnreadNotificationResponse = {
          totalUnread: res?.totalUnread ?? 0,
          moduleUnreadCounts: res?.moduleUnreadCounts ?? []
        };

        this.notificationData = notificationData;

        const selectedModule = notificationData.moduleUnreadCounts.find(
          (item) => item.moduleId === this.selectedNotificationModuleId
        );
        const fallbackModule =
          selectedModule || notificationData.moduleUnreadCounts[0];

        if (!fallbackModule) {
          this.notificationItems = [];
          this.selectedNotificationModuleId = null;
          this.selectedNotificationModuleName = '';
          return;
        }

        this.loadNotificationsForModule(
          fallbackModule.moduleId,
          fallbackModule.moduleName
        );
      },
      error: (err) => {
        console.error('Failed to load notification drawer data', err);
        this.notificationItems = [];
      }
    });
  }

  loadNotificationsForModule(moduleId: number, moduleName?: string): void {
    this.selectedNotificationModuleId = moduleId;
    this.selectedNotificationModuleName = moduleName || '';
    this.notificationListLoading = true;

    this.commonService.getNotificationsByModule(
      moduleId,
      0,
      this.notificationDrawerPageSize
    ).subscribe({
      next: (res: any) => {
        this.notificationItems = this.sortNotificationItems(
          Array.isArray(res?.data) ? res.data : []
        );
        if (!this.selectedNotificationModuleName && this.notificationItems.length) {
          this.selectedNotificationModuleName =
            this.notificationItems[0].moduleName || '';
        }
      },
      error: (err) => {
        console.error('Failed to load notifications', err);
        this.notificationItems = [];
      }
    }).add(() => {
      this.notificationListLoading = false;
    });
  }

  // Clicking a notification: an unread one is marked as read, and if it has a link the drawer closes and
  // the page opens (internal links such as /home/... through the router, full http(s) links in a new tab).
  openNotification(notification: NotificationItem): void {
    if (!notification.isRead) {
      this.markDrawerNotificationAsRead(notification);
    }
    const url = (notification.url || '').trim();
    if (!url) {
      return;
    }
    if (/^https?:\/\//i.test(url)) {
      window.open(url, '_blank');
      return;
    }
    this.onBellOpen(false);
    this.router.navigateByUrl(url.startsWith('/') ? url : '/' + url);
  }

  markDrawerNotificationAsRead(notification: NotificationItem, event?: MouseEvent): void {
    event?.stopPropagation();

    if (notification.isRead || notification.id == null || notification.moduleId == null) {
      return;
    }

    this.commonService.markAsRead({
      ids: [notification.id],
      moduleId: notification.moduleId
    }).subscribe({
      next: (res: any) => {
        if (!res?.success) {
          this.notification.error('Error', res?.message || 'Could not mark notification as read.');
          return;
        }

        this.notificationItems = this.sortNotificationItems(
          this.notificationItems.map((item) => {
            if ((item.notificationId || item.id) === (notification.notificationId || notification.id)) {
              return {
                ...item,
                isRead: true,
                readAt: item.readAt || new Date().toISOString()
              };
            }
            return item;
          })
        );

        this.notificationData = {
          ...this.notificationData,
          totalUnread: Math.max((this.notificationData.totalUnread || 0) - 1, 0),
          moduleUnreadCounts: (this.notificationData.moduleUnreadCounts || [])
            .map((item) => item.moduleId === notification.moduleId
              ? {...item, unreadCount: Math.max((item.unreadCount || 0) - 1, 0)}
              : item)
            .filter((item) => item.unreadCount > 0)
        };
      },
      error: (err) => {
        console.error('Failed to mark drawer notification as read', err);
        this.notification.error('Error', 'Could not mark notification as read.');
      }
    });
  }

  private sortNotificationItems(items: NotificationItem[]): NotificationItem[] {
    return [...items].sort((left, right) => {
      const unreadDelta = Number(!!left.isRead) - Number(!!right.isRead);
      if (unreadDelta !== 0) {
        return unreadDelta;
      }

      const leftTime = left.createdAt ? new Date(left.createdAt).getTime() : 0;
      const rightTime = right.createdAt ? new Date(right.createdAt).getTime() : 0;
      return rightTime - leftTime;
    });
  }

  trackByNotificationModule(index: number, item: ModuleCount): number {
    return item.moduleId;
  }

  trackByNotificationItem(index: number, item: NotificationItem): number {
    return item.notificationId || item.id || index;
  }



}
